import React, { useEffect, useState } from "react";
import "../../Transactions/styles/transactions.scss";
import "../../Users/style.scss";
import "./style.scss";
import {
  getRoleAndPermissionList,
  rolePermission,
  updatePermissionList,
} from "../../../utils/api";
import SubAdminPermission from "./SubAdminPermisson";
import { FilterWrapper } from "../../../assets/styles/FilterStyle";
import { isEmpty } from "../../../utils/common";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";
import LocalLoader from "../../../Components/Loader/LocalLoader";
import GloabalLoader from "../../../Components/Loader/GloabalLoader";


const PermissionManagement = () => {
  const [rolelist, setRoleList] = useState([]);
  const [checkValue, setCheckValue] = useState([]);
  const [role, setRole] = useState("ROLE_ADMIN");
  const [permissionList, setpermissionList] = useState([]);
  const [drawerShow, setDrawerShow] = useState(false);  
  const [loading,setLoading] = useState(false);
  const[msg,setMsg] = useState("")
  const getAllRole = () => {
    getRoleAndPermissionList().then((resp) => {
      const data = resp?.data?.data;
      setRoleList(data);
      handleRole({target:{value:"ROLE_ADMIN"}})
    });
  };

  useEffect(() => {
    getAllRole();
  }, []);

  const updatePermission = () => {
    const param = {
      roleCode: role,
      activePermission: [...checkValue],
    };
    setLoading(true);
    updatePermissionList(param).then((resp) => {
 setLoading(false);
      if(!role == " " ){
        if (resp?.data?.success) {
          if(resp?.data?.message==="SUCCESS")
          setMsg("Permission Updated Successfully");
         }
      }

     
      
    }).catch(()=>{
       setLoading(false);
    })
  };
  

  const handleUpdatePermission = () => {
    updatePermission();
  };
  const handleRole = (e) => {
   
    setRole(e.target.value);
    console.log("e.target.value",e.target.value)
    setLoading(true)
    rolePermission(e.target.value).then((res) => {
     
    setLoading(false)
      if (res?.data?.success) {
        const permission = res?.data?.data;
          
        let createPermissionArr = [];
        permission &&
          Object.keys(permission).map((CkeckPermissionkey, index) => {
            permission[CkeckPermissionkey].map((item, i) => {
              const perMissionString = CkeckPermissionkey + "/" + item.navName;
              createPermissionArr.push(perMissionString);
              
            });
          });

       
          setpermissionList([...createPermissionArr]);
       
      }
    
    }).catch(()=>{
        setLoading(false)
    })
  };
  useEffect(()=>{
    if(msg !== ""){
      setTimeout(()=>{
    setMsg("");
      },5000)
     
    }

  },[msg])

  return (
    
    <>
        {loading && <GloabalLoader  />}
     {  msg &&   <AlertWrapper className= "success globle">
					<span className="close" onClick={()=>setMsg("")}>
						×
					</span>
					{msg}
				</AlertWrapper>}
      <div className="transaction_main_container" style={{ padding: "30px" }}>
        <div className="transaction_head">
          <div className="transaction_heading" style={{ alignItems: "center" }}>
            <div className="transaction_left">
              <label>Manage Roles and Permissions</label>
            </div>
          </div>
        </div>
        <FilterWrapper>
          <div className=" flex filterBox">
            <div className="flex align-items">
              <lable
                className="filter-text"
                style={{ marginRight: "19px", fontWeight: "bold" }}
              >
                Select Role
              </lable>
              <div className="input-field">
                <select
                  onChange={handleRole}
                  className="input_select_field"
                  style={{
                    border: "none",
                    height: "32px",
                    backgroundColor: "#F4F8F8",
                  }}
                >
                 
                  <option value="ROLE_ADMIN">ADMIN</option>
                  <option value="ROLE_SUBADMIN">SUB ADMIN</option>
                  <option value="ROLE_RETAILER">RETAILER</option>
                  <option value="ROLE_MASTER_DISTRIBUTOR">MASTER DISTRIBUTOR</option>
                  <option value="ROLE_DISTRIBUTOR">DISTRIBUTOR</option>
                </select>
              </div>
            </div>
          </div>
        </FilterWrapper>




        <div className="container">
          <h1 className="main_heading">Permission List</h1>
          {rolelist &&
            Object.keys(rolelist).map((key, index) => {
              return (
                <SubAdminPermission
                  heading={key}
                  index={index}
                  role={rolelist[key]}
                  checkValue={checkValue}
                  setCheckValue={setCheckValue}
                  permissionList={permissionList}
                  userRole={role}
                
                />
              );
            })}
        </div>
        <div className="permission_btn">
        <button className="userlist_btn mt-20" onClick={handleUpdatePermission}>
          Update
        </button>
        </div>
        
      </div>
    </>
  );
};
export default PermissionManagement;
